function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { Spinner } from "../spinner/Spinner";
import { cnm } from "../utils";
var DEFAULT_ELEMENT = "button";
var variants = {
    "filled-primary": "\n    bg-primary-green\n    text-black\n    ring-primary-green/25\n  ",
    "filled-neutral": "\n    bg-gray-100 active:bg-gray-200\n    text-black\n    border-gray-600 disabled:border-gray-600\n    ring-black/25\n  ",
    "light-positive": "\n    bg-pastel-green\n    text-mid-green\n    ring-mid-green/25\n  ",
    "light-negative": "\n    bg-pastel-pink\n    text-error\n    ring-error/25\n  ",
    "light-neutral": "\n    bg-gray-600/10\n    text-gray-600\n    ring-gray-600/25\n  ",
    "text-neutral": "\n    bg-transparent active:bg-gray-600/5\n    text-gray-600\n    ring-gray-600/25\n  ",
    "text-positive": "\n    bg-transparent active:bg-mid-green/5\n    text-mid-green\n    ring-mid-green/25\n  ",
    "text-negative": "\n    bg-transparent active:bg-error/5\n    text-error\n    ring-error/25\n  ",
    "text-dark": "\n    bg-transparent active:bg-gray-400/5\n    text-black\n    ring-black/25\n  ",
    "text-light": "\n    bg-transparent active:bg-gray-200/5\n    text-white\n    ring-white/25\n  "
};
var sizes = {
    xs: "gap-x-2 text-sm",
    sm: "min-h-[2rem] px-4 text-sm",
    md: "min-h-[3rem] px-8 text-base"
};
var Button = /*#__PURE__*/ React.forwardRef(function(_param, ref) {
    var as = _param.as, children = _param.children, _type = _param.type, type = _type === void 0 ? "button" : _type, _variant = _param.variant, variant = _variant === void 0 ? "filled-primary" : _variant, _size = _param.size, size = _size === void 0 ? "md" : _size, startIcon = _param.startIcon, endIcon = _param.endIcon, isDisabled = _param.isDisabled, isLoading = _param.isLoading, className = _param.className, props = _objectWithoutProperties(_param, [
        "as",
        "children",
        "type",
        "variant",
        "size",
        "startIcon",
        "endIcon",
        "isDisabled",
        "isLoading",
        "className"
    ]);
    var Component = as || DEFAULT_ELEMENT;
    return /*#__PURE__*/ _jsxs(Component, _objectSpread({}, props, {
        ref: ref,
        type: type,
        disabled: isDisabled || isLoading,
        className: cnm("\n            inline-flex\n            select-none appearance-none\n            items-center justify-center gap-x-2\n            rounded-md border border-transparent font-medium\n            transition\n            focus:ring-4 focus-visible:outline-none\n\n            disabled:pointer-events-none\n            disabled:border-transparent\n            disabled:opacity-50\n          ", variants[variant], sizes[size], className),
        children: [
            isLoading && /*#__PURE__*/ _jsx(Spinner, {
                size: "sm",
                className: "text-current"
            }),
            !isLoading && startIcon,
            children,
            !isLoading && endIcon
        ]
    }));
});
export { Button };
